/*
 * @Author: Hong.Zhang
 * @Date: 2024-12-23 14:39:31
 * @Description:
 */
import { PRODUCT_NAMES } from './product';

export const EVENT_TRACKING_INSURANCE_CATEGORY_MAP = {
  [PRODUCT_NAMES.TRAVEL_DOMESTIC]: 'Travel Insurance',
  [PRODUCT_NAMES.ZURICH_SYARIAH_PA]: 'Personal Accident Insurance',
  [PRODUCT_NAMES.PA_HOSPITAL_CASH]: 'Personal Accident Insurance',
  [PRODUCT_NAMES.PA_HOME_PROTECTION]: 'Personal Accident Insurance',
  [PRODUCT_NAMES.MOTOLITE]: 'Motor Insurance',
};

export const EVENT_TRACKING_INSURER_NAME_MAP = {
  [PRODUCT_NAMES.TRAVEL_DOMESTIC]: 'Sompo Insurance',
  [PRODUCT_NAMES.ZURICH_SYARIAH_PA]: 'Zurich Syariah Insurance',
  [PRODUCT_NAMES.PA_HOSPITAL_CASH]: 'Victoria Insurance',
  [PRODUCT_NAMES.PA_HOME_PROTECTION]: 'Victoria Insurance',
  [PRODUCT_NAMES.MOTOLITE]: 'Zurich Insurance',
};

export const EVENT_TRACKING_INSURANCE_PRODUCT_NAME = {
  [PRODUCT_NAMES.TRAVEL_DOMESTIC]: 'Domestic Travel Insurance',
  [PRODUCT_NAMES.ZURICH_SYARIAH_PA]: 'Personal Accident Insurance',
  [PRODUCT_NAMES.PA_HOSPITAL_CASH]: 'PA Hospital Cashplan Insurance',
  [PRODUCT_NAMES.PA_HOME_PROTECTION]: 'PA Home Protection Insurance',
  [PRODUCT_NAMES.MOTOLITE]: 'Motolite Insurance',
};

export const EVENT_TRACKING_BUY_FOR_MAP = {
  [PRODUCT_NAMES.TRAVEL_DOMESTIC]: 'For myself',
  [PRODUCT_NAMES.ZURICH_SYARIAH_PA]: 'For myself',
  [PRODUCT_NAMES.PA_HOSPITAL_CASH]: 'For myself',
  [PRODUCT_NAMES.PA_HOME_PROTECTION]: 'For myself',
  [PRODUCT_NAMES.MOTOLITE]: 'For myself',
};

export const ERROR_TYPES = {
  GENERAL_SYSTEM_EXCEPTION: 'General error for system exception',
  GENERAL_ELIGIBILITY_ERROR: 'General error for failing eligible check',
};
